import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const midPoint = Math.ceil(categories.length / 2);
  const row1 = categories.slice(0, midPoint);
  const row2 = categories.slice(midPoint);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-4">
            <i className="ri-grid-line"></i>
            <span>Browse Categories</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Explore Product Categories
          </h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            Browse our curated product categories and discover the best spreadsheet finds across every style.
          </p>
        </div>

        <div className="space-y-3">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-2.5">
            {row1.map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex items-center gap-3 px-4 py-3 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
              >
                <div className="w-11 h-11 rounded-lg overflow-hidden flex-shrink-0 border border-background-200/50 group-hover:border-primary-200 transition-colors">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-900 whitespace-nowrap transition-colors">
                  {cat.name}
                </span>
              </a>
            ))}
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-2.5">
            {row2.map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex items-center gap-3 px-4 py-3 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
              >
                <div className="w-11 h-11 rounded-lg overflow-hidden flex-shrink-0 border border-background-200/50 group-hover:border-primary-200 transition-colors">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-900 whitespace-nowrap transition-colors">
                  {cat.name}
                </span>
              </a>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <div className="inline-flex items-center gap-2 px-6 py-2.5 bg-accent-100 rounded-full">
            <i className="ri-information-line text-sm text-accent-700"></i>
            <span className="text-xs text-accent-700 font-medium">
              All categories link to our partner platform for the best shopping experience
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}